export * from './register-teacher';
export * from '../../store/profile-link';
